import { render, staticRenderFns } from "./plan-affiliations-form-new.vue?vue&type=template&id=78c26691&scoped=true"
import script from "./plan-affiliations-form-new.vue?vue&type=script&lang=js"
export * from "./plan-affiliations-form-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c26691",
  null
  
)

export default component.exports